import { ActionType } from "../constants/existingCoords";

import { getAllMarksForMapApi, getMarkPreviewApi } from "../../api/marks/marks";

export const getAllMarksForMapAction = (map_id, tag_ids = []) => dispatch => {
  return getAllMarksForMapApi(map_id, tag_ids)
    .then(
      dispatch({
        type: ActionType.GET_ALL_MAP_MARKS_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.GET_ALL_MAP_MARKS_SUCCESS,
        payload:
          response.data && response.data.marks
            ? response.data.marks
            : []
      });
    })
    .catch(error => {
      dispatch({
        type: ActionType.GET_ALL_MAP_MARKS_ERRORS,
        payload: error.response
      });
    });
};

export const getMarkPreviewAction = id => async dispatch => {
  try {
    dispatch({ type: ActionType.GET_MARK_PREVIEW_START })

    const res = await getMarkPreviewApi(id);

    const arr = res.data.item.items.map(obj => {
      const { meta } = obj;
      const { type } = meta
      let res = {
        type,
        color: meta.color,
      }
      if (type === 'line' || type === 'square' || type === 'circle' || type === 'brush') {
        res.coords = meta.array
      } else if (meta.type === 'point') {
        res.id = obj.id
        res.title = obj.title
        res.x = meta.x
        res.y = meta.y
        res.radius = meta.radius
      }
      return res;
    })

    dispatch({
      type: ActionType.GET_MARK_PREVIEW_SUCCESS,
      payload: {
        submission_id: res.data.item.submission_id,
        items: arr,
      }
    })

  } catch (error) {
    dispatch({ type: ActionType.GET_MARK_PREVIEW_ERRORS, payload: error })
  }
}
